export default __webpack_public_path__ + "static/media/blacklisted-blue.e97c4bd6.svg";